module.exports = __webpack_public_path__ + "img/features-tileset-studio-stamps.bb0d6f86.png";